<a href={{this.topic.url}} target="_blank" rel="noopener noreferrer">
  <span class="title">{{html-safe this.topic.fancy_title}}</span>
  <div class="blurb"><RelativeDate @date={{@topic.created_at}} />
    -
    {{html-safe this.topic.blurb}}</div>
</a>